module.exports = __webpack_public_path__ + "img/edge_nature_meteo.fe1bf0b2.svg";